import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Download from '../Navigation/Download';
import NotFound from '../NavPages/NotFound';
import GetAuth from './GetAuth';

const GetUser = () => {
    return (
        <div>
             <>
        <Routes>
          <Route path="/" element={<GetAuth />} />
          <Route path="/download" element={<Download />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </>
        </div>
    );
}

export default GetUser;
